import { apiPost } from '@shared/api/api'
import type { User } from '../types/auth'
import {
  getStoredUser,
  setStoredAccessToken,
  setStoredActiveOrganizationId,
  setStoredExpiresAt,
  setStoredUser,
  authStorageKeys,
} from '../utils/sessionStorage'
import {
  getImpersonationReturnPath,
  getImpersonationState,
  isImpersonationActive,
  restoreAdminSession,
  saveAdminSessionBackup,
  setImpersonationState,
} from '../utils/impersonationStorage'

interface ImpersonationResponse {
  access_token: string
  expires_at: number
  organization_id: string
  organization_name: string
}

export const impersonationService = {
  isActive: isImpersonationActive,
  getState: getImpersonationState,

  // Начать режим просмотра: сохранить суперадмин-сессию (localStorage-бэкап),
  // подменить токен и перезагрузить приложение под целевой организацией.
  start: async (organizationId: string): Promise<void> => {
    const response = await apiPost<ImpersonationResponse>(
      `/admin/organizations/${organizationId}/impersonate`
    )

    const adminUser = getStoredUser()
    saveAdminSessionBackup()

    setStoredAccessToken(response.access_token)
    setStoredExpiresAt(String(response.expires_at))
    // Refresh-токена у режима просмотра нет: интерцептор не должен его рефрешить.
    localStorage.removeItem(authStorageKeys.refreshToken)
    setStoredActiveOrganizationId(response.organization_id)
    if (adminUser) {
      const viewerUser: User = {
        ...adminUser,
        role: 'org_admin',
        organization_id: response.organization_id,
      }
      setStoredUser(viewerUser)
    }

    setImpersonationState({
      organization_id: response.organization_id,
      organization_name: response.organization_name,
      expires_at: response.expires_at,
      return_path: `/admin/organizations/${response.organization_id}`,
    })

    window.location.assign('/')
  },

  returnPath: getImpersonationReturnPath,

  // Вернуться в админку: восстановить суперадмин-сессию.
  end: (): void => {
    const returnPath = getImpersonationReturnPath()
    restoreAdminSession()
    window.location.assign(returnPath)
  },
}
